import { FormControl, Grid, InputLabel, Select, TextField, Typography, Box } from '@mui/material';
import api from "../services/api";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListTemaPadre, setListEstados } from "../redux/evaluacionSlice";
import { FormHelperText as HelperText } from '@mui/material';

// Mantenimiento de los temas de evaluacion: el catalogo jerarquico de temas.
// Un tema puede colgar de otro (IdTemaPadre), como el resto de catalogos.
const TemaEvaluacion = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.evaluacion.entity);
    const defaultEntity = useSelector((state) => state.evaluacion.defaultEntity);
    const listTemaPadre = useSelector((state) => state.evaluacion.listTemaPadre);
    const listEstados = useSelector((state) => state.evaluacion.listEstados);
    const validate = useSelector((state) => state.evaluacion.validationActive);
    const dispatch = useDispatch();

    var validation = {
        nombre: {
            error: entity.nombre == null || entity.nombre.trim().length < 1,
            message: "Falta ingresar el nombre",
        },
        orden: {
            error: entity.orden == null || entity.orden < 0,
            message: "Falta ingresar el orden",
        },
        idEstado: {
            error: entity.idEstado == null || entity.idEstado == 0,
            message: "Falta ingresar el estado",
        },
    }

    const fetchEntity = useCallback(async () => {
        if (parseInt(params.id || "0") <= 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        await api.get("/Evaluacion/GetsTemaEvaluacionView")
            .then((response) => {
                const encontrado = (response.data?.data || []).find((row) => row.id == params.id);

                if (encontrado == null) {
                    dispatch(setEntity(defaultEntity));
                }
                else {
                    dispatch(setEntity(encontrado));
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }, [])

    const fetchListTemaPadre = useCallback(async () => {
        const response = await api.get("/Evaluacion/GetsTemaEvaluacionPadreView")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListTemaPadre(response?.data?.data || []));
    }, [])

    const fetchListEstados = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=1")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListEstados(response?.data?.data || []));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListTemaPadre();
        fetchListEstados();
        dispatch(setValidationMessage(messagesValidation()));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        });

        return messages;
    }

    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={12} sm={6}>
                    <FormControl required fullWidth error={validate.nombre && validation.nombre.error}>
                        <TextField
                            name="nombre"
                            label="Nombre"
                            fullWidth
                            value={entity.nombre}
                            onChange={setDataEntity}
                            error={validate.nombre && validation.nombre.error}
                            helperText={validate.nombre && validation.nombre.error ? validation.nombre.message : ""}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <TextField
                            name="descripcion"
                            label="Descripcion"
                            fullWidth
                            value={entity.descripcion}
                            onChange={setDataEntity}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="input-temapadre">Tema padre</InputLabel>
                        <Select
                            native
                            label="Tema padre"
                            value={entity.idTemaPadre == null ? 0 : entity.idTemaPadre}
                            onChange={(event, newValue) => {
                                dispatch(setData({ name: "idTemaPadre", value: event.target.value }))
                            }}
                            inputProps={{
                                name: 'idTemaPadre',
                                id: 'input-temapadre',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Ninguno)"}</option>
                            {listTemaPadre.map((row) => (
                                <option key={row.id} value={row.id}>{row.nombre}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.orden && validation.orden.error}>
                        <TextField
                            required
                            name="orden"
                            label="Orden"
                            type="number"
                            fullWidth
                            value={entity.orden}
                            onChange={setDataEntity}
                            error={validate.orden && validation.orden.error}
                            helperText={validate.orden && validation.orden.error ? validation.orden.message : ""}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idEstado && validation.idEstado.error}>
                        <InputLabel htmlFor="input-estado">Estado</InputLabel>
                        <Select
                            native
                            label="Estado"
                            value={entity.idEstado}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idEstado',
                                id: 'input-estado',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEstados.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idEstado && validation.idEstado.error ? validation.idEstado.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default TemaEvaluacion;
